import React from 'react';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';

const useStyles = buildUseStyles('ThreadListLabel', (theme) => ({
  root: {
    margin: theme.spacing(0.5, 0),
  },
}));

const ThreadListLabel = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  const { threadsCollection } = useMessagesContext();

  return (
    <Typography
      className={classNames(classes.root)}
      variant={isMobile ? 'h4' : 'h6'}
      color="black"
      weight="extraBold"
    >
      {threadsCollection?.meta()?.queries()?.head()?.attr('prompt') || 'Threads'}
    </Typography>
  );
};

ThreadListLabel.defaultProps = {};

ThreadListLabel.propTypes = {};

export { ThreadListLabel };
